export const isFloifyEmail = (email) => {
    let emailRegex = /@floify\.com\s*$/
    if (emailRegex.test(email)) {
        return true
    } else {
        return false;
    }
}
